export default "__VITE_PUBLIC_ASSET__fd23c36d__"